/**
 * Board geometry constants.
 * All linear units are in world units; scale to taste.
 */
export const BOARD = {
  /** Side length of each star arm (standard Chinese Checkers = 5) */
  SIDE_LENGTH: 5,
  /** Total number of holes on the board */
  TOTAL_HOLES: 121,
  /** Marbles per player */
  MARBLES_PER_PLAYER: 10,
  /** Max players */
  MAX_PLAYERS: 6,
  /** Hex grid spacing between adjacent hole centers */
  HEX_SIZE: 1.0,
  /** Marble radius (world units) */
  MARBLE_RADIUS: 0.4,
  /** Hole radius = marble radius × 1.05 (5% clearance) */
  HOLE_RADIUS: 0.42,
  /** Visual hole depth */
  HOLE_DEPTH: 0.08,
  /** Wooden frame thickness */
  BOARD_THICKNESS: 0.6,
  /** Felt layer thickness */
  FELT_THICKNESS: 0.12,
} as const;

/** Top-level alias for the common import. */
export const MARBLE_RADIUS = BOARD.MARBLE_RADIUS;

/** Player colors — matching the palette defined in SPEC.md */
export const PLAYER_COLORS: readonly [string, string, string, string, string, string] = [
  '#E63946', // Red (player 0)
  '#457B9D', // Blue (player 1)
  '#F4D35E', // Yellow (player 2)
  '#2D6A4F', // Green (player 3)
  '#F77F00', // Orange (player 4)
  '#7B2D8B', // Purple (player 5)
] as const;

export const PLAYER_NAMES = ['Red', 'Blue', 'Yellow', 'Green', 'Orange', 'Purple'] as const;
